//
import UserModel from '@/models/General/GUser'

// payment_date` are not allowed. Allowed filter(s) are `g_user_id, g_authorizer_user_id, search, period_year, period_month
export default [
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Encargado',
            model: UserModel,
            noObject: true,
        },
    },
    {
        name: 'g_authorizer_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
        },
    },
]
